/*
 * @Author: 谭聪 156638174@qq.com
 * @FilePath: /mall-fe/src/views/web/home/NewIndex/components/HomeBannerNew.tsx
 * @Description: 渲染首页的横幅轮播图区域和相关内容
 *
 */
/* eslint-disable react/jsx-no-useless-fragment */
import { Carousel } from 'antd';
import { getWaitAuditShop } from 'api/user';
import Color from 'color';
import ConditionCarousel from 'comps/ConditionCarousel';
import PlaceholderImage from 'comps/PlaceholderImage';
import { MenuAim } from 'es6-menu-aim';
import { useBannerImage } from 'hooks/useImage';
import useUrl from 'hooks/useUrl';
import ArrowIcon from 'icons/arrow';
import Audit from 'icons/home/spsh';
import Bzjgl from 'icons/home/bzjgl';
import Bzjjn from 'icons/home/bzjjn';
// import Ddgl from 'icons/dingdanguanli';
import Jjdfb from 'icons/home/jjdbj';
// import Shgl from 'icons/shouhuoguanli';
import Receiving from 'icons/home/receiving';
import Trumpet from 'icons/trumpet';
import OrderCart from 'icons/home/order-cart';
import HeadIcon from 'images/head-icon';
import HeadIconW from 'images/head-iconw';
import { CAROUSEL_AUTOPLAY_SPEED } from 'libs/cons';
import { DeviceContext, SiteContext, UserContext } from 'libs/contexts';
import { webps } from 'libs/imgs';
import { strEllipsis } from 'libs/utils';
import { useRouter } from 'next/router';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { cls } from 'reactutils';
import { CurrentUserTypeSource } from 'libs/enums';
import { isInDop } from 'libs/dopUtil.js';
import bgImg from 'images/cscec3b/home/bg.png';
import cxzqImg from 'images/cscec3b/home/chuangxin.png';
import gjzqImg from 'images/cscec3b/home/gangjin.png';
import zyzqImg from 'images/cscec3b/home/ziying.png';
import jjzqImg from 'images/cscec3b/home/jignjia.png';
import MallNews from './MallNews';
webps[HeadIcon] = HeadIconW;

const prefectureList = [
  {
    title: '创新专区',
    desc: '提供高效能的专业服务',
    img: cxzqImg,
    path: '/pages/innovative',
  },
  {
    title: '钢筋专区',
    desc: '钢铁生态圈资源新整合',
    img: gjzqImg,
    path: '/pages/gjzq',
  },
  {
    title: '自营专区',
    desc: '商城自营·优选好货·品质保证',
    img: zyzqImg,
    path: '/pages/zyzq',
  },
  {
    title: '严选优服',
    desc: '精选好物一站购，品质生活轻松享',
    img: jjzqImg,
    path: '/yf-shop',
  },
];

interface CategoryItem {
  title: string;
  iconUrl: string;
  id: string;
  link: string;
  children: CategoryItem[];
}

type BannerProps = {
  banners: BannerInfo[];
  bulletinData: BulletinDataInfo[];
  categorys: CategoryItem[];
};

/**
 * HomeBannerNew组件用于渲染首页的横幅轮播图区域和相关内容。
 * @param {Object} banners - 轮播图数据的数组，包含每个轮播图的信息。
 * @param {Object[]} bulletinData - 公告数据的数组，包含每个公告的信息。
 * @param {Object[]} categorys - 分类数据的数组，包含每个分类的信息。
 */
export default function HomeBannerNew({ banners, bulletinData, categorys }: BannerProps) {
  // 创建一个ref用于Carousel组件的引用
  const ref = useRef() as any;
  // 从useBannerImage钩子中解构所需函数
  const { renderBannerImg, buildBannerImgSrc, handleErrorImg } = useBannerImage();
  const userInfo = useContext(UserContext);

  // 获取SiteContext中的数据
  return (
    <div className="banner-wrap">
      <div className="banner-box">
        <div className="category">
          <CategoryPanel categorys={categorys} />
        </div>
        {/* <div className="right-panel">
          <RightContentPanel bulletinData={bulletinData} />
        </div> */}
        <div style={{ width: '950px' }}>
          {/* 渲染轮播图区域 */}
          <div className="carousel">
            <Carousel
              ref={ref}
              autoplay
              autoplaySpeed={5000}
              swipeToSlide={true}
              draggable={true}
              infinite={true}
              useTransform={false}
              pauseOnDotsHover={true}
              appendDots={(dots) => {
                const customDots = React.Children.map(dots, (el, index) => {
                  return React.cloneElement(el as any, {
                    onMouseEnter: () => {
                      ref.current?.goTo(index);
                    },
                  });
                });
                return (
                  <div>
                    <ul>{customDots}</ul>
                  </div>
                );
              }}
            >
              {/* 遍历轮播图数据，渲染每个轮播图 */}
              {banners.map((b, index) => {
                // 增值服务页面没有供应商身份不跳转
                const Tag =
                  b.link && (!b.link.includes('/pages/extra-serve') || userInfo?.isSupplier)
                    ? 'a'
                    : 'span';
                return (
                  <div className="content" key={index}>
                    <Tag
                      key={index}
                      className="banner"
                      href={b.link}
                      // eslint-disable-next-line react/jsx-no-target-blank
                      target={b.link ? (b.link.startsWith('/') ? '_top' : '_blank') : undefined}
                    >
                      {renderBannerImg && (
                        <img
                          onError={handleErrorImg}
                          className="banner-img"
                          src={buildBannerImgSrc(b.image)}
                          alt="banner"
                        />
                      )}
                    </Tag>
                  </div>
                );
              })}
            </Carousel>
          </div>
          <div className="prefecture">
            {prefectureList.map((item) => (
              <div
                className="prefecture-item"
                key={item.path}
                onClick={() => {
                  window.open(item.path);
                }}
                style={{ backgroundImage: `url(${item.img})` }}
              >
                <div className="title">{item.title}</div>
                <div className="desc">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <MallNews bulletinData={bulletinData} />
      <style jsx>{`
        .banner-wrap {
          height: 630px;
          padding-top: 20px;
          background-color: #fff;
          background-image: url(${bgImg});
          background-size: cover;
        }
        .banner-box {
          width: 1200px;
          margin: 0 auto;
          position: relative;
          display: flex;
        }
        .category,
        .right-panel {
          height: 488px;
          // position: absolute;
          // top: 19px;
          // z-index: 8;
        }
        .category {
          width: 250px;
          // left: 0;
          // z-index: 9;
        }
        // .right-panel {
        //   right: 0;
        // }
        .carousel {
          width: calc(100% - 16px);
          margin-left: 16px;
          height: 346px;
          border-radius: 6px;
          position: relative;
          overflow: hidden;
        }
        .content {
          text-align: center;
        }
        .prefecture {
          display: flex;
          justify-content: space-between;
          margin-top: 16px;
          margin-left: 16px;
        }
        .prefecture-item {
          width: 225px;
          height: 126px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-size: contain;
          border-radius: 6px;
          color: #fff;
          cursor: pointer;
        }
        .prefecture-item .title {
          font-size: 26px;
          line-height: 36px;
          margin-bottom: 2px;
        }
        .banner {
          height: 346px;
          position: relative;
        }
        .banner-img {
          display: inline-block !important;
          height: 346px;
          max-width: 100%;
          object-fit: cover;
        }

        .carousel :global(.ant-carousel) {
          height: 346px;
        }
        .carousel :global(.ant-carousel) :global(.slick-dots) {
          z-index: 8 !important;
        }
        .carousel :global(.ant-carousel) :global(.slick-dots li) {
          width: auto;
          height: 8px;
          margin: 0 6px;
        }
        .carousel :global(.ant-carousel) :global(.slick-dots li > button) {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: rgba(0, 0, 0, 0.3);
        }
        .carousel
          :global(.ant-carousel)
          :global(.slick-dots li.slick-active > button) {
          width: 12px;
          border-radius: 4px;
          background-color: #ffffff;
          box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.02);
        }
        .carousel :global(.ant-carousel) :global(.slick-dots-bottom) {
          bottom: 30px;
          height: 8px;
          padding: 0;
        }
      `}</style>
    </div>
  );
}

/**
 * CategoryPanel组件用于渲染分类面板，显示不同的分类选项。
 * @param {Object[]} categorys - 分类数据的数组，包含每个分类的信息。
 */
export const CategoryPanel = ({ categorys }: { categorys: CategoryItem[] }) => {
  // 获取SiteContext中的数据
  const site = useContext(SiteContext);
  const [categoryIndex, setCategoryIndex] = useState<number | null>(null);
  const menuRootRef = useRef<HTMLUListElement>();
  const menuAim = useRef(null);
  const { getPublicUrl } = useUrl();
  // 在组件挂载时初始化菜单
  useEffect(() => {
    function handleInitMenu() {
      const menuAimConfig = {
        isRoot: false,
        activate: (targetRow: any) => {
          setCategoryIndex(Number(targetRow.getAttribute('data-index')));
        },
      };
      const menuRoot = menuRootRef.current;
      if (!menuRoot.children) return;
      menuAim.current = new MenuAim(menuRoot, menuAimConfig);
      for (let i = 0; i < menuRoot.children.length; i++) {
        menuAim.current.hookUp(menuRoot.children[i] as HTMLElement);
      }
    }
    handleInitMenu();

    // 在组件卸载时取消菜单的事件绑定
    return () => {
      if (menuAim.current) {
        menuAim.current.detach();
      }
    };
  }, [categorys]);

  return (
    <div className="category-box">
      {/* 渲染分类列表 */}
      <ul
        className="category-list"
        ref={menuRootRef}
        onMouseLeave={() => {
          menuAim.current?.deactivateRow();
          setCategoryIndex(null);
        }}
      >
        {/* 分类标题 */}
        <li className="category-title-item">
          <div className="category-title">全部商品分类</div>
        </li>
        {!!categorys?.length &&
          categorys.slice(0, 4).map((item, index) => (
            <li
              className={cls('category-item', categoryIndex === index && 'active')}
              data-index={index}
              key={index}
            >
              <a className="category" href={item.link} title={item.title}>
                <div className="category-icon">
                  {!!item.iconUrl && (
                    <PlaceholderImage
                      src={getPublicUrl(item.iconUrl)}
                      width="28px"
                      height="28px"
                      alt="icon"
                    />
                  )}
                </div>
                <div style={{ width: '172px' }}>
                  <div className="first-cate">
                    <span className={cls('name')}>{item.title}</span>
                    <span className="arrow-icon">
                      <ArrowIcon />
                    </span>
                  </div>
                  <div className="second-cate">
                    {item?.children?.slice(0, 2)?.map((subItem, subIndex) => (
                      <div className="sub-item">
                        <a href={subItem.link} title={subItem.title} key={subIndex}>
                          {subItem.title}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </a>
              <span className="line-box" key={index} style={{ width: '20px', height: '488px' }}>
                {' '}
              </span>
              {categoryIndex === index && !!item.children?.length && (
                <div className="category-panel">
                  {item.children.map((subItem, subIndex) => (
                    <div className="category-panel-item" key={item.title + subIndex}>
                      <div className="category-panel-title">
                        <a href={subItem.link} title={subItem.title}>
                          {subItem.title}
                        </a>
                      </div>
                      {/* 遍历子分类的子分类数据，渲染第三层内容 */}
                      <div className="category-panel-list">
                        {!!subItem.children?.length &&
                          subItem.children.map((thirdItem, thirdIndex) => (
                            <a
                              href={thirdItem.link}
                              title={thirdItem.title}
                              key={item.title + subIndex + thirdIndex}
                            >
                              {thirdItem.title}
                            </a>
                          ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </li>
          ))}
      </ul>
      <style jsx>{`
        .category-box {
          width: 100%;
          height: 100%;
          background: #fff;
          padding: 0px 0px 32px;
          border-radius: 8px;
        }
        .category-list {
          height: 456px;
          overflow: hidden;
          margin-bottom: 0px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .category-title-item {
          padding: 14px 20px;
          border-bottom: 1px solid #f0f0f0;
          text-align: center;
          margin-bottom: -20px;
        }
        .category-title {
          font-size: 18px;
          font-weight: 700;
          color: #333;
          line-height: 24px;
        }
        .category-item {
          color: #333;
          width: 100%;
          padding: 12px 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          word-wrap: normal;
          white-space: nowrap;
        }
        .category-item.active {
          background-color: ${site?.global?.platformMainColor}1A;
        }
        .category-item.active > .category .name {
          color: ${site?.global?.platformMainColor};
        }
        .category-item.active
          > .category
          .arrow-icon
          :global(svg)
          :global(path) {
          fill: ${site?.global?.platformMainColor};
        }

        .category {
          display: flex;
          justify-content: space-between;
          width: 100%;
        }
        .first-cate {
          display: flex;
          width: 172px;
        }
        .second-cate {
          display: flex;
          line-height: 22px;
        }
        .sub-item {
          max-width: 76px;
          margin-right: 20px;
        }
        .sub-item:last-child {
          margin-right: 0;
        }
        .sub-item a {
          color: #666;
        }
        .sub-item a:hover {
          color: ${site?.global?.platformMainColor};
        }
        .category .name {
          width: 152px;
          padding-right: 10px;
          font-size: 18px;
          line-height: 28px;
          font-weight: 500;
          margin-bottom: 12px;
          color: #333;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .category .no-icon {
          padding-left: 0px;
        }
        .category-icon {
          width: 28px;
          height: 28px;
          overflow: hidden;
          flex: none;
          margin-right: 10px;
        }
        .category-icon img {
          object-fit: contain;
        }
        .arrow-icon {
          flex: 0 0 auto;
          padding-top: 3px;
        }
        .arrow-icon :global(svg) {
          width: 12px;
          height: 12px;
        }
        .arrow-icon :global(svg) :global(path) {
          fill: #999;
        }
        .line-box {
          width: 100px;
          height: 488px;
          position: absolute;
          top: 0px;
          left: 250px;
          z-index: 9;
        }
        .category-panel {
          position: absolute;
          width: 656px;
          height: 488px;
          overflow: auto;
          top: 0px;
          left: 266px;
          padding: 24px 20px;
          background-color: #fff;
          box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.10);
          z-index: 10;
          border-radius: 6px;
        }
        .category-panel-item {
          white-space: normal;
        }
        .category-panel-item + .category-panel-item {
          margin-top: 24px;
        }
        .category-panel-title {
          line-height: 22px;
          font-size: 14px;
          padding: 5px 10px;
        }
        .category-panel-title > a {
          color: #333;
          font-weight: 700;
          cursor: pointer;
        }
        .category-panel-list {
          font-size: 14px;
        }
        .category-panel-list > a {
          display: inline-block;
          vertical-align: middle;
          line-height: 22px;
          padding: 5px 10px;
          color: #666;
          cursor: pointer;
        }
        .category-panel-title > a:hover,
        .category-panel-list > a:hover {
          color: ${site?.global?.platformMainColor};
        }
      `}</style>
    </div>
  );
};

/**
 * RightContentPanel组件用于渲染右侧内容面板，显示用户信息和相关功能入口。
 * @param {Object[]} bulletinData - 公告数据的数组，包含每个公告的信息。
 */
var RightContentPanel = ({ bulletinData }: { bulletinData: BulletinDataInfo[] }) => {
  const { buildImgSrc } = useContext(DeviceContext);
  const site = useContext(SiteContext);
  const userInfo = useContext(UserContext);
  const router = useRouter();
  const [auditCount, setAuditCount] = useState(0);
  // 创建状态用于存储不同身份的路由
  const [purcharserRoute, setPurcharserRoute] = useState<string>('');
  const [supplierRoute, setSupplierRoute] = useState<string>('');
  const [portalURL, setPortalURL] = useState<string>('/portal/');

  const [inDop, setInDop] = useState(false);

  const checkDopInfo = async () => {
    setInDop(await isInDop());
  };

  useEffect(() => {
    checkDopInfo();
  }, []);

  // 在组件挂载时根据用户信息获取待审核商品数量
  useEffect(() => {
    (async () => {
      if (userInfo?.currentUserType === CurrentUserTypeSource.personal) {
        setPortalURL(`/portal?perferKey=personal`);
      }
      if (!userInfo?.isSystemUser) return;
      const res = await getWaitAuditShop();

      if (res.code === 200) {
        setAuditCount(res.data);
      }
    })();
  }, [userInfo]);

  // 在组件挂载时根据路由信息设置不同身份的跳转链接
  useEffect(() => {
    // 直接使用 location.href 获取完整的当前URL，更简单可靠
    const retUrl = location.href;
    setPurcharserRoute(`/sso/login?return_url=${encodeURIComponent(retUrl)}&role=purcharser`);
    setSupplierRoute(`/sso/xlogin?return_url=${encodeURIComponent(retUrl)}`);
  }, [router.asPath]);

  // 轮播图的设置项
  const carouselSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    dotPosition: 'right' as const,
    autoplaySpeed: CAROUSEL_AUTOPLAY_SPEED,
  };

  return (
    <>
      {/* 渲染用户面板 */}
      <div className="banner-user-panel">
        <div className="panel-user-info">
          <div className="head-icon">
            <img alt="头像" src={buildImgSrc(HeadIcon)} />
          </div>
          {/* 根据用户信息渲染用户欢迎信息和登录按钮 */}
          {userInfo && userInfo.name ? (
            <div className="user-info-box">
              <p className="hello ellipsis">
                <span className="gray">欢迎回来，</span>
                {userInfo.name}
              </p>
              <div className="login-btn">
                <a
                  target="_top"
                  className="btn btn-primary"
                  title="进入工作台"
                  onClick={() => {
                    window.selfOpen(portalURL, inDop ? '_blank' : '_top');
                  }}
                >
                  进入工作台
                </a>
              </div>
            </div>
          ) : (
            <div className="user-info-box">
              <p className="hello">欢迎来到三局严选~</p>
              <div className="login-btn no-user">
                <a
                  target="_top"
                  className="btn btn-primary"
                  href={supplierRoute}
                  title="企业或个人登录"
                >
                  企业或个人登录
                </a>
                <a target="_top" className="btn" href={purcharserRoute} title="中建三局内部登录">
                  中建三局内部登录
                </a>
              </div>
            </div>
          )}
        </div>
        {userInfo === undefined || userInfo === null ? (
          <div className="route-btn-box">
            <div className="placeholder-box" />
          </div>
        ) : (
          <div className="route-btn-box">
            {/* 多身份展示优先级：采购商 -> 供应商 -> 运营(管理员) */}
            {userInfo.isPurchaser ? (
              <>
                <a
                  className="route-btn"
                  title="订单管理"
                  rel="noreferrer"
                  onClick={() => {
                    window.selfOpen('/portal/tender/purchaser/trade/list');
                  }}
                >
                  {/* <Ddgl /> */}
                  <OrderCart />
                  订单管理
                </a>
                <a
                  className="route-btn"
                  title="收货管理"
                  rel="noreferrer"
                  onClick={() => {
                    window.selfOpen('/portal/tender/purchaser/receiving/list');
                  }}
                >
                  <Receiving />
                  {/* <Shgl /> */}
                  收货管理
                </a>
              </>
            ) : (
              <>
                {!!userInfo?.isSupplier ? (
                  <>
                    <a
                      className="route-btn"
                      title="竞价单报价"
                      rel="noreferrer"
                      onClick={() => {
                        window.selfOpen('/portal/tender/supplier/competition/list');
                      }}
                    >
                      <Jjdfb />
                      竞价单报价
                    </a>
                    <a
                      className="route-btn"
                      title="保证金缴纳"
                      rel="noreferrer"
                      onClick={() => {
                        window.selfOpen('/portal/tender/supplier/bondTaskDetail/list');
                      }}
                    >
                      <Bzjjn />
                      保证金缴纳
                    </a>
                  </>
                ) : (
                  <>
                    {userInfo.isSystemUser && (
                      <>
                        <a
                          className="route-btn"
                          title="商品审核"
                          rel="noreferrer"
                          onClick={() => {
                            window.selfOpen('/portal/mall/admin/audit');
                          }}
                        >
                          <Audit />
                          <div
                            className="route-btn-text"
                            title={`商品审核 (${Math.max(auditCount, 0)})`}
                          >
                            商品审核 ({Math.max(auditCount, 0)})
                          </div>
                        </a>
                        <a
                          className="route-btn"
                          title="保证金管理"
                          rel="noreferrer"
                          onClick={() => {
                            window.selfOpen('/portal/tender/admin/bondChargeTask/list');
                          }}
                        >
                          <Bzjgl />
                          保证金管理
                        </a>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        )}

        <div className="events">
          <div className="events-title">
            <Trumpet />
            <span className="text">平台动态</span>
          </div>
          <ConditionCarousel
            {...carouselSettings}
            slidesToShow={userInfo ? 3 : 4}
            minSlides={userInfo ? 3 : 4}
          >
            {bulletinData && bulletinData.length
              ? bulletinData.map((ev) => <BulletinV2 key={ev.sysNo} ev={ev} />)
              : ''}
          </ConditionCarousel>
        </div>
      </div>
      <style jsx>{`
        .banner-user-panel {
          background: #fff;
          height: 412px;
          width: 200px;
          padding: 20px 13px 0;
          overflow: hidden;
        }
        .panel-user-info {
          height: 150px;
          text-align: center;
        }
        .head-icon {
          height: 54px;
          text-align: center;
          margin-bottom: 14px;
        }
        .head-icon img {
          width: 54px;
          height: 54px;
        }
        .hello {
          margin-bottom: 0px;
          line-height: 14px;
          color: #333;
        }
        .gray {
          color: #999;
        }
        .login-btn {
          margin-top: 21px;
          position: relative;
          z-index: 1;
        }
        .login-btn.no-user {
          margin-top: 20px;
        }
        .login-btn .btn {
          display: block;
          height: 36px;
          margin-top: 15px;
          font-size: 14px;
          line-height: 36px;
          color: ${site?.global?.platformMainColor};
          border: 1px solid ${site?.global?.platformMainColor};
          background-color: #fff;
          transition: all 0s;
          border-radius: 3px;
        }
        .login-btn .btn-primary {
          background-color: ${site?.global?.platformMainColor};
          color: #fff;
        }
        .login-btn .btn:first-child {
          margin-top: 0px;
        }
        .login-btn .btn:hover {
          background-color: ${Color(site?.global?.platformMainColor).darken(0.1)};
          color: #fff;
        }

        .placeholder-box {
          height: 60px;
        }

        .route-btn-box {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          // padding: 0 9px;
          margin-bottom: 15px;
        }
        // .route-btn-box :global(svg path) {
        //   fill: ${site?.global?.platformMainColor};
        // }
        .route-btn {
          width: 96px;
          height: 80px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: #333333;
          border-radius: 10px;
          background-color: #f4f4f4;
          cursor: pointer;
        }
        .route-btn:first-child {
          margin-right: 12px;
        }
        .route-btn:hover {
          background-color: ${Color(site?.global?.platformMainColor).alpha(0.1)};
        }
        .route-btn :global(.route-btn-text) {
          width: 100%;
          padding: 0 8px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .route-btn :global(svg) {
          margin-bottom: 3px;
        }
        .events-title {
          line-height: 22px;
          font-size: 14px;
          padding-top: 12px;
          color: #333;
          border-top: 1px dashed #E9E9E9;
          padding-left: 3px;
        }
        .events-title .text {
          padding-left: 8px;
        }
        // .banner-user-panel :global(.ant-carousel .slick-vertical .slick-slide) {
        //   height: 50px;
        // }
      `}</style>
    </>
  );
};

/**
 * BulletinV2组件用于渲染公告项，展示公告标题和相关链接。
 * @param {Object} ev - 公告信息对象。
 */
var BulletinV2 = ({ ev }: any) => {
  const site = useContext(SiteContext);
  const userInfo = useContext(UserContext);
  const router = useRouter();
  // 使用strEllipsis函数对公告标题进行省略处理
  const content = strEllipsis(ev.title, ev.newFlag ? 16 : 19);
  const [retUrl, setRetUrl] = useState('');
  useEffect(() => {
    // 直接使用 location.href 获取完整的当前URL，更简单可靠
    setRetUrl(location.href);
  }, [router.asPath]);

  return (
    <div className="event-item-notice" key={`event-${ev.sysNo}`}>
      <div className="left">
        {/* 根据是否为新公告渲染不同样式 */}
        <div className={cls('dot', ev.newFlag && 'newdot')} />
        {/* 根据用户是否登录渲染不同的链接 */}
        <a
          rel="noreferrer"
          target="_blank"
          title={ev?.title}
          className="link"
          onClick={() => {
            const url = userInfo
              ? `/bulletin/${ev.sysNo}`
              : `/sso/login?return_url=${encodeURIComponent(retUrl)}`;
            window.selfOpen(url);
          }}
        >
          {/* 根据新公告标志渲染NEW标签 */}
          {ev.newFlag && <span className="new">NEW</span>}
          {content}
        </a>
      </div>
      <style jsx>{`
        .event-item-notice {
          display: flex;
          overflow: hidden;
          padding: 5px 0;
        }

        .left {
          display: flex;
          align-items: center;
          font-size: 12px;
          line-height: 22px;
          width: 100%;
        }

        .new {
          width: 37px;
          height: 20px;
          background: rgba(255, 119, 35, 0.1);
          border-radius: 3px;
          color: #FF7723;
          display: inline-flex;
          font-size: 12px;
          flex-shrink: 0;
          justify-content: center;
          align-items: center;
          margin-right: 4px;
        }
        .link {
          margin-right: 4px;
          color: inherit;
          flex: 1;
          overflow: hidden;
          white-space: nowrap; 
          text-overflow: ellipsis;
        }
        .link:hover {
          color: var(--primaryColor);
        }
        .left:hover .dot {
          background: var(--primaryColor);
        }
        .dot {
          border-radius: 100%;
          background: #D9D9D9;
          width: 6px;
          height: 6px;
          flex-shrink: 0;
          line-height: 18px;
          margin-right: 4px;
        }
        .newdot {
          background-color: #FF7723;
        }
        .event-item-notice:hover .dot {
          background: ${site?.global?.platformMainColor};
        }
      `}</style>
    </div>
  );
};
